/** Eporner's main categories (84 left of the 87 on eporner.com/cats/, read once on 2026-10-25, minus `all`, `uncategorized` and `gay`: the
 * Orientation option covers that). The official API takes no category, only a search word, so choosing one searches its `query` word:
 * the nearest thing to the site's category page, not the same list. */
export const EPORNER_CATEGORIES = [
  { slug: "4k-porn", label: "4K", query: "4k" },
  { slug: "hd-1080p", label: "HD 1080p", query: "hd 1080p" },
  { slug: "60fps", label: "60 fps", query: "60fps" },
  { slug: "vr-porn", label: "VR", query: "vr" },
  { slug: "japanese", label: "Japanese", query: "japanese" },
  { slug: "anal", label: "Anal", query: "anal" },
  { slug: "pov-porn", label: "POV", query: "pov" },
  { slug: "indian", label: "Indian", query: "indian" },
  { slug: "milf", label: "Milf", query: "milf" },
  { slug: "hentai", label: "Hentai", query: "hentai" },
  { slug: "bbw", label: "BBW", query: "bbw" },
  { slug: "pinay", label: "Pinay", query: "pinay" },
  { slug: "amateur", label: "Amateur", query: "amateur" },
  { slug: "asian", label: "Asian", query: "asian" },
  { slug: "asmr", label: "ASMR", query: "asmr" },
  { slug: "bdsm", label: "BDSM", query: "bdsm" },
  { slug: "big-ass", label: "Big ass", query: "big ass" },
  { slug: "big-dick", label: "Big dick", query: "big dick" },
  { slug: "big-tits", label: "Big tits", query: "big tits" },
  { slug: "cosplay", label: "Cosplay", query: "cosplay" },
  { slug: "creampie", label: "Creampie", query: "creampie" },
  { slug: "cuckold", label: "Cuckold", query: "cuckold" },
  { slug: "ebony", label: "Ebony", query: "ebony" },
  { slug: "footjob", label: "Footjob", query: "footjob" },
  { slug: "group-sex", label: "Group sex", query: "group sex" },
  { slug: "hardcore", label: "Hardcore", query: "hardcore" },
  { slug: "homemade", label: "Homemade", query: "homemade" },
  { slug: "indonesia", label: "Indonesia", query: "indonesia" },
  { slug: "interracial", label: "Interracial", query: "interracial" },
  { slug: "latina", label: "Latina", query: "latina" },
  { slug: "massage", label: "Massage", query: "massage" },
  { slug: "mature", label: "Mature", query: "mature" },
  { slug: "orgy", label: "Orgy", query: "orgy" },
  { slug: "redhead", label: "Redhead", query: "redhead" },
  { slug: "stepmom", label: "Stepmom", query: "stepmom" },
  { slug: "stepsister", label: "Stepsister", query: "stepsister" },
  { slug: "teens", label: "Teens", query: "teens" },
  { slug: "threesome", label: "Threesome", query: "threesome" },
  { slug: "vintage", label: "Vintage", query: "vintage" },
  { slug: "lesbians", label: "Lesbians", query: "lesbians" },
  { slug: "shemale", label: "Shemale", query: "shemale" },
  { slug: "ai", label: "AI", query: "ai" },
  { slug: "bisexual", label: "Bisexual", query: "bisexual" },
  { slug: "blonde", label: "Blonde", query: "blonde" },
  { slug: "blowjob", label: "Blowjob", query: "blowjob" },
  { slug: "bondage", label: "Bondage", query: "bondage" },
  { slug: "brunette", label: "Brunette", query: "brunette" },
  { slug: "bukkake", label: "Bukkake", query: "bukkake" },
  { slug: "casting", label: "Casting", query: "casting" },
  { slug: "compilation", label: "Compilation", query: "compilation" },
  { slug: "cumshot", label: "Cumshot", query: "cumshot" },
  { slug: "double-penetration", label: "Double penetration", query: "double penetration" },
  { slug: "fat", label: "Fat", query: "fat" },
  { slug: "fetish", label: "Fetish", query: "fetish" },
  { slug: "fisting", label: "Fisting", query: "fisting" },
  { slug: "for-women", label: "For women", query: "for women" },
  { slug: "gloryhole", label: "Gloryhole", query: "gloryhole" },
  { slug: "handjob", label: "Handjob", query: "handjob" },
  { slug: "hd-sex", label: "HD sex", query: "hd sex" },
  { slug: "hotel", label: "Hotel", query: "hotel" },
  { slug: "hotwife", label: "Hotwife", query: "hotwife" },
  { slug: "housewives", label: "Housewives", query: "housewives" },
  { slug: "hq-porn", label: "HQ", query: "hq" },
  { slug: "lingerie", label: "Lingerie", query: "lingerie" },
  { slug: "masturbation", label: "Masturbation", query: "masturbation" },
  { slug: "nurse", label: "Nurse", query: "nurse" },
  { slug: "office", label: "Office", query: "office" },
  { slug: "old-man", label: "Old man", query: "old man" },
  { slug: "outdoor", label: "Outdoor", query: "outdoor" },
  { slug: "pawg", label: "PAWG", query: "pawg" },
  { slug: "petite", label: "Petite", query: "petite" },
  { slug: "pornstar", label: "Pornstar", query: "pornstar" },
  { slug: "pregnant", label: "Pregnant", query: "pregnant" },
  { slug: "public", label: "Public", query: "public" },
  { slug: "small-tits", label: "Small tits", query: "small tits" },
  { slug: "squirt", label: "Squirt", query: "squirt" },
  { slug: "striptease", label: "Striptease", query: "striptease" },
  { slug: "students", label: "Students", query: "students" },
  { slug: "swingers", label: "Swingers", query: "swingers" },
  { slug: "toys", label: "Toys", query: "toys" },
  { slug: "uniform", label: "Uniform", query: "uniform" },
  { slug: "webcam", label: "Webcam", query: "webcam" },
  { slug: "sleep", label: "Sleep", query: "sleep" },
  { slug: "doctor", label: "Doctor", query: "doctor" },
] as const
